import { render } from "./AnnouncementAdminComponent.vue?vue&type=template&id=7f4f57a4&scoped=true&ts=true"
import script from "./AnnouncementAdminComponent.vue?vue&type=script&lang=ts"
export * from "./AnnouncementAdminComponent.vue?vue&type=script&lang=ts"

import "./AnnouncementAdminComponent.vue?vue&type=style&index=0&id=7f4f57a4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f4f57a4"]])

export default __exports__